<template lang="pug">
	span.email-component(v-if="ready")
		span(v-if="!emailCaptureSuccess")
			b-row(v-if="showTypeOfUser")
					b-col.text-center(md="12")
						sfc-select-wrapper(:flat="true" :error="typeOfUserError" :errorMessage="typeOfUserErrorMessage")
							select.text-white(v-model="typeOfUser" @change="validForm()")
								option(value="" hidden disabled) I am a ...
								option(value="parent") Parent
								option(value="grandparent") Grandparent
								option(value="advisor") Financial Advisor
								option(value="other") Other
			b-row(v-if="showState")
				b-col.text-center(md="12")
					sfc-select-wrapper(:flat="true" :error="stateOfResidenceError" :errorMessage="stateOfResidenceErrorMessage")
						select.text-white(v-model="stateOfResidence" @change="validForm()")
							option(value="" hidden disabled) State of residence
							option(v-for="state of states" :value="state.id")
								| {{state.name}}
			.tb
				label
					input(:value="value" @input="validForm($event)" type="text" placeholder="your@email.com" tabindex="-1")
					span.error(v-if="inputError")
						| {{computedInputErrorMessage}}
			a.btn.sfc-blue(@click="submit($event)" :href="resourceUrl" :target="target") {{buttonText}}
		div(v-if="emailCaptureSuccess")
			h4 {{successMessageTitle || 'Thank you!'}}
			p {{successMessage}}

</template>
<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	h4
		font-size: body-font-size-lg
		color: sfc-blue

</style>
<script>
	export default {
		data() {
			let states = [{
					id: 1,
					name: "Alabama",
					string_id: "AL"
				},
				{
					id: 2,
					name: "Alaska",
					string_id: "AK"
				},
				{
					id: 3,
					name: "Arizona",
					string_id: "AZ"
				},
				{
					id: 4,
					name: "Arkansas",
					string_id: "AR"
				},
				{
					id: 5,
					name: "California",
					string_id: "CA"
				},
				{
					id: 6,
					name: "Colorado",
					string_id: "CO"
				},
				{
					id: 7,
					name: "Connecticut",
					string_id: "CT"
				},
				{
					id: 8,
					name: "Delaware",
					string_id: "DE"
				},
				{
					id: 9,
					name: "District of Columbia",
					string_id: "DC"
				},
				{
					id: 10,
					name: "Florida",
					string_id: "FL"
				},
				{
					id: 11,
					name: "Georgia",
					string_id: "GA"
				},
				{
					id: 12,
					name: "Hawaii",
					string_id: "HI"
				},
				{
					id: 13,
					name: "Idaho",
					string_id: "ID"
				},
				{
					id: 14,
					name: "Illinois",
					string_id: "IL"
				},
				{
					id: 15,
					name: "Indiana",
					string_id: "IN"
				},
				{
					id: 16,
					name: "Iowa",
					string_id: "IA"
				},
				{
					id: 17,
					name: "Kansas",
					string_id: "KS"
				},
				{
					id: 18,
					name: "Kentucky",
					string_id: "KY"
				},
				{
					id: 19,
					name: "Louisiana",
					string_id: "LA"
				},
				{
					id: 20,
					name: "Maine",
					string_id: "ME"
				},
				{
					id: 21,
					name: "Maryland",
					string_id: "MD"
				},
				{
					id: 22,
					name: "Massachusetts",
					string_id: "MA"
				},
				{
					id: 23,
					name: "Michigan",
					string_id: "MI"
				},
				{
					id: 24,
					name: "Minnesota",
					string_id: "MN"
				},
				{
					id: 25,
					name: "Mississippi",
					string_id: "MS"
				},
				{
					id: 26,
					name: "Missouri",
					string_id: "MO"
				},
				{
					id: 27,
					name: "Montana",
					string_id: "MT"
				},
				{
					id: 28,
					name: "Nebraska",
					string_id: "NE"
				},
				{
					id: 29,
					name: "Nevada",
					string_id: "NV"
				},
				{
					id: 30,
					name: "New Hampshire",
					string_id: "NH"
				},
				{
					id: 31,
					name: "New Jersey",
					string_id: "NJ"
				},
				{
					id: 32,
					name: "New Mexico",
					string_id: "NM"
				},
				{
					id: 33,
					name: "New York",
					string_id: "NY"
				},
				{
					id: 34,
					name: "North Carolina",
					string_id: "NC"
				},
				{
					id: 35,
					name: "North Dakota",
					string_id: "ND"
				},
				{
					id: 36,
					name: "Ohio",
					string_id: "OH"
				},
				{
					id: 37,
					name: "Oklahoma",
					string_id: "OK"
				},
				{
					id: 38,
					name: "Oregon",
					string_id: "OR"
				},
				{
					id: 39,
					name: "Pennsylvania",
					string_id: "PA"
				},
				{
					id: 40,
					name: "Rhode Island",
					string_id: "RI"
				},
				{
					id: 41,
					name: "South Carolina",
					string_id: "SC"
				},
				{
					id: 42,
					name: "South Dakota",
					string_id: "SD"
				},
				{
					id: 43,
					name: "Tennessee",
					string_id: "TN"
				},
				{
					id: 44,
					name: "Texas",
					string_id: "TX"
				},
				{
					id: 45,
					name: "Utah",
					string_id: "UT"
				},
				{
					id: 46,
					name: "Vermont",
					string_id: "VT"
				},
				{
					id: 47,
					name: "Virginia",
					string_id: "VA"
				},
				{
					id: 48,
					name: "Washington",
					string_id: "WA"
				},
				{
					id: 49,
					name: "West Virginia",
					string_id: "WV"
				},
				{
					id: 50,
					name: "Wisconsin",
					string_id: "WI"
				},
				{
					id: 51,
					name: "Wyoming",
					string_id: "WY"
				}
			]
			return {
				states,
				validateInputOnChange: false,
				inputError: false,
				typeOfUserErrorMessage: "",
				typeOfUserError: false,
				stateOfResidence: "",
				typeOfUser: "",
				stateOfResidenceErrorMessage: "",
				stateOfResidenceError: false,
				componentInputErrorMessage: "",
				ready: true
			}
		},

		props: ['value', 'inputErrorMessage', 'successMessageTitle', 'successMessage', 'onFailure', 'emailCaptureSuccess', 'buttonText', 'resourceUrl', 'showState', 'showTypeOfUser'],

		methods: {
			validForm(event) {
				if(event){
					this.$emit('input', event.target.value)
				}
				if (this.validateInputOnChange) {
					this.inputError = false
					this.inputErrorMessage = ""
					this.typeOfUserErrorMessage = ""
					this.typeOfUserError = false
					this.stateOfResidenceErrorMessage = ""
					this.stateOfResidenceError = false



					if (this.showState && (!this.stateOfResidence || this.stateOfResidence == "")) {
						this.stateOfResidenceError = true
						this.stateOfResidenceErrorMessage = "Please select one"
					}

					if (this.showTypeOfUser && (!this.typeOfUser || this.typeOfUser == "")) {
						this.typeOfUserError = true
						this.typeOfUserErrorMessage = "Please select one"
					}

					const regex = /^(([^<>()\[\]\\.,;:\s@“]+(\.[^<>()\[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					if (!regex.test(this.value)) {
						this.inputError = true
						this.componentInputErrorMessage = "Please enter a valid email"
					}

					return !this.stateOfResidenceError && !this.typeOfUserError && !this.inputError
				}
			},
			submit(clickEvent) {
				this.validateInputOnChange = true
				if (this.validForm()) {
					this.$emit('success', this.typeOfUser, this.stateOfResidence)
				}else{
					clickEvent.preventDefault()
				}
			}
		},
		computed:{
			computedInputErrorMessage(){
				if(this.inputErrorMessage && this.inputErrorMessage != ""){
					return this.inputErrorMessage
				}else{
					return this.componentInputErrorMessage
				}
			},
			target(){
				if(this.resourceUrl){
					return "_blank"
				}
				return "_self"
			}
		}
	}
</script>
